export enum AppType {
    None = 0,
    TargetedSSA = 1,
    SpecialAwards = 2,
    Unauthorized = 3
}
